import React, { useState } from "react";
import { gtag_report_conversion } from "../../common/pageUtils";
import RequestAppraisal from "../../forms/request_appraisal";
import Modal from "react-bootstrap/Modal";

import "../StickyCtaBtn/StickyCtaBtn.scss";

const StickyCtaDynamic = ({
  page,
  department,
  page_url,
  type,
  sub_type,
  to_user_id,
  onClose,
  sticky_data,
  show_sticky,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible || ! show_sticky) return null;

  const handleClick = () => {
    if (sticky_data?.cta_type === "modal") setIsOpen(true);
    if (sticky_data?.cta_type === "scroll" && sticky_data?.cta_scroll_to) {
      const id = sticky_data?.cta_scroll_to.replace("#", "");
      const offset = document.getElementById(id)?.offsetTop - 200 || 0;
      window.scrollTo({ top: offset, behavior: "smooth" });
    }
    gtag_report_conversion();
  };

  return (
    <>
      <div className="sticky-cta-section">
        <div className="cta-wrapper">
          <button type="button" className="btn btn-primary" onClick={handleClick}>
            <i className="right-slide"></i>
            {sticky_data?.cta_label && sticky_data?.cta_label }
          </button>

          <span
            className="cta-close"
            onClick={() => {
              setIsVisible(false);
              onClose?.();
            }}
          >
            ×
          </span>
        </div>
      </div>

      {sticky_data?.cta_type === "modal" && (
        <Modal
          id="popup_modal_form"
          show={isOpen}
          onHide={() => setIsOpen(false)}
          backdrop="static"
          keyboard={false}
          className="member-contact-modal"
        >
          <Modal.Header closeButton className="contact-close-btn memberPopup">
            <Modal.Title className="w-100">
              <h3 className="text-center content-primary-color mb-0">
                {sticky_data?.cta_label}
              </h3>
              <p>
                 Complete the form and one of our local experts will be in touch to arrange your market appraisal.
              </p>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <RequestAppraisal
              department={department}
              page_url={page_url}
              type={type}
              sub_type={sub_type}
              to_user_id={to_user_id}
              popup_form={true}
            />
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default StickyCtaDynamic;